<template>
    <tis-button
        class="group block text-sm tracking-wide rounded-sm flex flex-col pr-3 phone:pr-8 last:pr-0"
        :url="url"
        :full-redirect="fullRedirect"
        :target="target"
        :title="title"
        :analytics-data="{Post: postSlug, Category: categorySlug}"
    >
        <svg-icon
            :icon="socialIcon"
            class="social-share-icon text-gold-500 w-6 h-6 mb-2 inline-block transform group-hover:scale-110 transition-scale" />
        <svg-icon
            icon="arrow-horizontal"
            class="text-gold-500 w-6 h-4 text-white inline-block" />
    </tis-button>
</template>

<script>
import TisButton from '@whisper/components/buttons/TisButton';
import SvgIcon from '@whisper/components/icons/SvgIcon';

export default {
  components: {
    TisButton,
    SvgIcon,
  },
  props: ['url', 'target', 'text', 'fullRedirect', 'title', 'socialIcon', 'postSlug', 'categorySlug'],
};
</script>
